import * as actionType from "../constants";
import * as commonData from "../Common";
import action from ".";

export const hideColumn = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${url}attribute/hide`, {
      method: "post",
      body: JSON.stringify(inputs),
    });

    const result = await response.json();
    if (result.code === 200) {
      dispatch({
        type: actionType.HIDE_COLUMN,
        payload: {
          data: result.data,
          field: inputs.attributes,
          status_type: inputs.status_type,
          hidden_count: result.data.hidden_column_count,
        },
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const showColumns = (inputs) => async (dispatch) => {
  const api = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${api}attribute/hide`, {
      method: "post",
      body: JSON.stringify(inputs),
    });

    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({
        type: actionType.SHOW_COLUMNS,
        payload: { ...rdata.data, ...inputs },
      });
    }
  } catch (error) {
    console.log(error);
  }
};
